const emailRegExp = new RegExp(/^[^\s@]+@([^\s@.,]+\.)+[^\s@.,]{2,}$/);

export const validateEmail = (email: string) => emailRegExp.test(email);
